import { Tabs } from '@mantine/core';
import { groupBy } from 'lodash';
import type { FC } from 'react';
import { useEffect, useMemo, useState } from 'react';
import { Container } from '@/DesignSystem/Component';
import { categoryCategoryParentId } from '@/Module/Auth/Store/Slice/AuthSlice';
import type { IEntity } from '@/Module/Core/Model/DataModel';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
import SubscriptionPageTabInner from '@/Module/Subscription/Component/SubscriptionPageContainer/SubscriptionPageTabInner';
import type { ISubscriptionPlan } from '@/Module/Subscription/Model/DataModel';
import type { TColor } from '@/Module/Subscription/Model/Types/TColors';
import { selectedSubscriptionPlanActiveSelector } from '@/Module/Subscription/Store/Selector/selectedSubscriptionPlanActiveSelector';
interface IGroupGroup {
  duration: number;
  items: ISubscriptionPlan[];
}
interface IGroup {
  typeId: IEntity['id'];
  groups: IGroupGroup[];
  color?: TColor;
}
interface SubscriptionPageTabProps {
  home?: boolean;
}
const SubscriptionPageTab: FC<SubscriptionPageTabProps> = ({
  home
}) => {
  const dispatch = useAppDispatch();
  const typeList = useAppSelector(state => state.subscription.typeList);
  const planList = useAppSelector(state => selectedSubscriptionPlanActiveSelector(state));
  const categoryId = useAppSelector(state => state.auth.categoryCategory?.parentId);
  const isLoggedIn = useAppSelector(state => state.auth.isLoggedIn);
  const [mounted, setMounted] = useState(false);
  const [activeTab, setActiveTab] = useState<string>(categoryId ? String(categoryId + 1004) : '1005');
  const title = useMemo(() => {
    switch (categoryId) {
      case 1:
        return 'دبستان';
      case 2:
        return 'متوسطه اول';
      case 3:
        return 'متوسطه دوم ';
      default:
        return '';
    }
  }, [categoryId]);
  const data = useMemo(() => {
    const outPut: IGroup[] = [];
    Object.entries(groupBy(planList, 'subscriptionTypeId')).forEach(([typeId, list]) => {
      const groupByTypeId: IGroupGroup[] = [];
      Object.entries(groupBy(list, 'duration')).forEach(([duration, groupList]) => {
        groupByTypeId.push({
          duration: Number(duration),
          items: groupList
        });
      });
      outPut.push({
        typeId,
        groups: groupByTypeId,
        color: groupByTypeId[0].items[0].color
      });
    });
    return !isLoggedIn ? outPut : outPut.slice(categoryId! - 1, categoryId);
  }, [planList]);
  useEffect(() => {
    const fetchData = async () => {
      dispatch(categoryCategoryParentId(Number(activeTab) - 1004));
    };
    if (mounted) {
      fetchData();
    }
  }, [activeTab]);
  useEffect(() => {
    setMounted(true);
  }, []);
  const STYLES: Record<TColor, string[]> = {
    pink: ['hover:text-pinkFour text-blueFive', 'text-pinkFour  '],
    green: [' hover:text-greenFour text-blueFive', 'text-greenFour  '],
    blue: [' hover:text-blueFour text-blueFive', 'text-blueFour  '],
    orange: [' hover:text-orangeFour text-blueFive', 'text-orangeFour  ']
  };
  const tabStyle = useMemo(() => {
    const output: Record<IGroup['typeId'], string> = {};
    data.forEach(item => {
      if (item.color === 'pink') {
        output[item.typeId] = 'pink';
      } else if (item.color === 'green') {
        output[item.typeId] = 'green';
      } else if (item.color === 'orange') {
        output[item.typeId] = 'orange';
      } else {
        output[item.typeId] = 'blue';
      }
    });
    return output;
  }, [data, isLoggedIn]);
  return <div className=" pb-12 pt-4 sm:py-12 " id="subscription" data-sentry-component="SubscriptionPageTab" data-sentry-source-file="SubscriptionPageTab.tsx">
      <Container className="relative max-w-[1100px]  " data-sentry-element="Container" data-sentry-source-file="SubscriptionPageTab.tsx">
        <div>
          {home ? <h2 className="mb-1 text-2xl font-extrabold text-blueFive sm:mb-6 sm:text-4xl">خرید اشتراک</h2> : <h1 className="mb-1 text-2xl font-extrabold text-blueFive sm:mb-6 sm:text-4xl">
              خرید اشتراک {isLoggedIn && title}
            </h1>}
          <p className="font-semibold text-blackThree">
            می&zwnj;توانید با انتخاب پلن&zwnj;های مختلف، زمان و هزینه خود را مدیریت کنید:
          </p>
        </div>

        <Tabs aria-label={tabStyle[categoryId ? categoryId + 1004 : Number(activeTab)] as any} unstyled classNames={{
        root: 'flex flex-col mt-0 relative',
        list: 'flex text-center    w-full mx-auto flex-wrap flex-nowrap',
        panel: ' mx-auto  mt-2 w-full ',
        tab: ' flex-1 flex  border-l-[1px] last:border-0 border-blackThree items-center font-bold justify-center px-4 sm:px-6 py-2 text-[12px] sm:text-base  transition-all duration-200 ease-in-out    first:mr-0 disabled:cursor-not-allowed disabled:text-gray-400 disabled:dark:text-gray-500'
      }} onChange={value => setActiveTab(value ?? '1005')} defaultValue={activeTab} data-sentry-element="Tabs" data-sentry-source-file="SubscriptionPageTab.tsx">
          <div className="pb-4 pt-24 sm:pt-28" />
          {!isLoggedIn && <Tabs.List>
              {data?.map(({
            typeId,
            color
          }) => <Tabs.Tab className={`${STYLES[color as TColor][0]} ${typeId === activeTab && `${STYLES[color as TColor][1]}`}`} key={typeList.find(type => type.id === Number(typeId))?.subscriptionTypeName ?? ''} value={typeId as string}>
                  {typeList.find(type => type.id === Number(typeId))?.subscriptionTypeName ?? ''}
                </Tabs.Tab>)}
            </Tabs.List>}

          {data?.map(({
          typeId,
          groups,
          color
        }) => <Tabs.Panel value={typeId as string} key={typeList.find(type => type.id === Number(typeId))?.subscriptionTypeName ?? ''}>
              <SubscriptionPageTabInner iGroupGroup={groups} color={color} />
            </Tabs.Panel>)}
        </Tabs>
      </Container>
    </div>;
};
export default SubscriptionPageTab;